'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
require('./InputContainer.css');
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Input container.
 */
var InputContainer = function InputContainer(_ref) {
  var label = _ref.label,
    labelFor = _ref.labelFor,
    required = _ref.required,
    children = _ref.children,
    helpText = _ref.helpText,
    error = _ref.error,
    sb = _ref.sb;
  var inputClass = (0, _classnames2.default)('c-input', {
    'c-input--error': error
  }, {
    'u-spacer-bottom': sb
  });
  var helpTextClass = (0, _classnames2.default)('c-input__help-text', {
    'c-input__help-text--error': error
  });
  return _react2.default.createElement('div', {
    className: inputClass
  }, _react2.default.createElement('label', {
    className: 'c-input__label',
    htmlFor: labelFor
  }, label, required && _react2.default.createElement('abbr', {
    title: required
  }, '*')), _react2.default.createElement('div', {
    className: 'c-input__controls'
  }, children, helpText && _react2.default.createElement('div', {
    className: helpTextClass
  }, helpText)));
};
InputContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Required set label for the text input*/
  label: _propTypes2.default.string,
  /** Id of the input field for which the label is for*/
  labelFor: _propTypes2.default.string,
  /** If set this field gets an "*" and this message will be shown on hover (Possible values are "Required field" or "Verplicht veld"*/
  required: _propTypes2.default.string,
  /** Adds a help text under the field*/
  helpText: _propTypes2.default.string,
  /** If true it will indicate there is an error*/
  error: _propTypes2.default.bool,
  /** Add children that are inputs*/
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  /** Spacer for bottom input container*/
  sb: _propTypes2.default.bool
} : {};
exports.default = InputContainer;